/**
 * Check if the object has at least 1 value that's falsy.
 * @param obj The object who's values we're checking for null.
 * @returns True, if any of the values are falsy.
 */
export const hasSomeFalsyValues = (obj: Record<string, unknown>) =>
  Object.values(obj).some((val) => !val);

/**
 *  Returns true if all attributes in the object is a falsy value.
 * @param obj The object to check.
 * @returns True, if all attributes are falsy, false if there is at least one non falsy attribute.
 */
export const hasAllFalsyValues = (obj: Record<string, unknown>) =>
  Object.values(obj).every((x) => !x);

/**
 *  Returns true if at least one attributes in the object isn't a falsy value.
 * @param obj The object to check.
 * @returns True, if at least one attributes isn't falsy, false if all attributes are falsy.
 */
export const hasSomeNonFalsyValues = (obj: object) =>
  Object.values(obj).some((x) => x);
